import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useGlobalSnackbar } from "src/context/SnackbarContext";
import { callFlowQueryKeys } from "../../ConfigureCallFlow/queries/call-flow.query";
import { uploadVoiceMessageRecording } from "../actions/upload-voice-message-recording.action";
import { deleteVoiceMessageRecording } from "../actions/delete-voice-message-recording.action";
import { VoiceMessageSlot } from "../constants/voice-message-slots";

export const useVoiceMessageRecordingMutation = () => {
    const queryClient = useQueryClient();
    const { showSnackbar } = useGlobalSnackbar();

    const upload = useMutation({
        mutationFn: ({
            companyId,
            slotKey,
            audio,
        }: {
            companyId: number;
            slotKey: VoiceMessageSlot;
            audio: File;
        }) => uploadVoiceMessageRecording(companyId, slotKey, audio),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: callFlowQueryKeys.all });
            showSnackbar("Recording saved successfully", "success");
        },

        onError: () => {
            showSnackbar("Failed to save recording", "error");
        },
    });

    const remove = useMutation({
        mutationFn: ({ companyId, slotKey }: { companyId: number; slotKey: VoiceMessageSlot }) =>
            deleteVoiceMessageRecording(companyId, slotKey),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: callFlowQueryKeys.all });
            showSnackbar("Recording removed successfully", "success");
        },

        onError: () => {
            showSnackbar("Failed to remove recording", "error");
        },
    });

    return { upload, remove };
};
